import React, {useEffect} from 'react';

import {Icon} from '@/ui-kits';
import {DataExport, DeleteAccount} from '@/components/patient-setting';
import {ErrorCodes, getErrorMessage, getSuccessMessage, SuccessCodes} from '@/utils/getMessages';
import {useToast} from '@/hooks';
import {useDispatch, useSelector} from 'react-redux';
import {authFailureStatus, authSuccessStatus} from '@/services/redux/selectors';
import {getAccountTicketStatusRequest, resetAuthMessage} from '@/services/redux/slices';

export const PatientSettingsScreen: React.FC = () => {
  // ===========================
  // hooks
  // ===========================
  const {showToast} = useToast();
  const dispatch = useDispatch();
  // ===========================
  // selectors
  // ===========================
  const success = useSelector(authSuccessStatus) as SuccessCodes;
  const faliure = useSelector(authFailureStatus) as ErrorCodes;

  // ===========================
  // side effects
  // ===========================
  useEffect(() => {
    dispatch(getAccountTicketStatusRequest());
  }, []);

  useEffect(() => {
    if (success) {
      if (['S-10084', 'S-10086', 'S-10085', 'S-10055'].includes(success)) {
        showToast(getSuccessMessage(success), 'success');
      }
    }
    if (faliure) {
      if (['E-10149', 'E-10018', 'E-10019', 'E-10146', 'E-10001', 'E-10178'].includes(faliure)) {
        showToast(getErrorMessage(faliure), 'failure');
      }
    }

    return () => {
      dispatch(resetAuthMessage());
    };
  }, [success, faliure]);
  return (
    <div className="min-h-screen bg-[#F9FAFB] p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <div className="flex gap-1 mb-4">
            <Icon type="management_setting" className="size-14 p-3 rounded-lg bg-[#CBEBFB66]" />
            <div className="flex flex-col mx-1">
              <h1 className="text-xl sm:text-2xl font-FigtreeBold text-ui_blue mb-0">Account Management</h1>
              <h6 className="text-m sm:text-[16px] text-ui_blue mt-0 leading-tight">Manage your account data and settings</h6>
            </div>
          </div>
          <DataExport />
          <DeleteAccount />
        </div>
      </div>
    </div>
  );
};
